import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MagnifyIcon = _resolveComponent("MagnifyIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Searchbar = _resolveComponent("Searchbar")!

  return (_ctx.isMobile)
    ? (_openBlock(), _createBlock(_component_NcButton, {
        key: 0,
        class: "memories-menu-item search-menu",
        variant: "tertiary-no-background",
        title: _ctx.t('memories', 'Search'),
        "aria-label": _ctx.t('memories', 'Search'),
        onClick: _ctx.search
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_MagnifyIcon, { size: 20 })
        ]),
        _: 1
      }, 8, ["title", "aria-label", "onClick"]))
    : (_openBlock(), _createBlock(_component_Searchbar, { key: 1 }))
}